import { render, staticRenderFns } from "./proposal-by-kpi.vue?vue&type=template&id=53fd13f8&scoped=true&"
import script from "./proposal-by-kpi.vue?vue&type=script&lang=js&"
export * from "./proposal-by-kpi.vue?vue&type=script&lang=js&"
import style0 from "./proposal-by-kpi.vue?vue&type=style&index=0&id=53fd13f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fd13f8",
  null
  
)

export default component.exports